import { ID_DANG_KY_KHAM } from '../../utils/Constant';
import { formatTrangThaiBenhNhan } from '../../utils/FormatUtils';

export const PATIENT_COLUMNS = [
	{
		name: 'TT',
		field: '',
		headerStyle: {
			maxWidth: '30px',
		},
		render: (rowData: any, index: number) => formatTrangThaiBenhNhan(rowData?.currStatusColor),
	},
	{
		name: 'Tên bệnh nhân',
		field: '',
		headerStyle: {
			minWidth: '175px',
		},
		render: (rowData: any) => {
			const display = rowData?.display ? JSON.parse(rowData?.display) : {};

			return (
				<div className="text-system ">
					<div className="flex m-0">
						<span
							className={`text-uppercase ${
								rowData?.visitTypeId === ID_DANG_KY_KHAM.CAP_CUU
									? 'color-error'
									: ''
							}`}
						>
							{rowData?.patientName || ''}
						</span>
						{
							<span style={display?.style}>
								&nbsp;{display?.text ? `(${display?.text})` : ''}
							</span>
						}
						{rowData?.visitSortWeight ? (
							<span className="text-danger">&nbsp;(Ưu tiên)</span>
						) : (
							''
						)}
					</div>
					<div className="flex m-0">
						<span className="text-uppercase fw-semibold">
							{rowData?.patientCode || ''}
						</span>
						<span className="px-1"> - </span>
						<span>{rowData?.objectTypeName || 'BHYT'}</span>
						<span className="px-1"> - </span>
						<span>{rowData?.patientGender || ''}</span>
					</div>
				</div>
			);
		},
	},
];
